import tabsSlice from './tabs';
import tabsDataSlice from './tabsData';

export default {
  tabs: tabsSlice,
  tabsData: tabsDataSlice,
};
